import { MenuItem, Select, SelectProps } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

function ChartSelect({
  value,
  onChange,
  children,
}: PropsWithChildren<Pick<SelectProps, 'value' | 'onChange'>>) {
  return (
    <Select
      value={value}
      onChange={onChange}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        PaperProps: {
          style: {
            boxShadow: '0px 0px 8px 0px rgba(0, 30, 81, 0.12)',
            borderRadius: '8px',
            maxHeight: '240px',
          },
        },
        MenuListProps: {
          style: {
            padding: 0,
          },
        },
      }}
      sx={{
        height: '33px',
        fontSize: '12px',
        border: 'none',
        color: '#777777',
        background: '#F5F5F5',
        fontWeight: 700,
        boxShadow: 'none',
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        minWidth: 70,
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      {children}
    </Select>
  );
}

export default ChartSelect;
